import axios from 'axios'
import countries from './countries'
import { getItemLocalStorage } from './helper.utils'
import request from '@utils/requests'
import endpoints from '@constants/endpoints.json'
import useAuthStore from '@store/auth.store.js'

// to-do: revert after demo with client
const institution = import.meta.env.VITE_INSTITUATION || 'kenya'
const country = countries[institution]
const baseUrl = import.meta.env.VITE_BASE_URL
const organization = JSON.parse(
  JSON.stringify(endpoints[`${import.meta.env.VITE_BRAND}`]),
)

async function makeRequest(
  endpoint,
  method = 'GET',
  data = {},
  params,
  headers,
) {
  const accountData = getItemLocalStorage('accountData') || {}


  console.log("accountData.USERNAME:", accountData?.USERNAME)
  console.log("data.USERNAME:", data?.USERNAME)

  const respbody = {
    INSTID: country.id || "RUBISKE",
    ...data,
    ...(accountData?.USERNAME
      ? { USERNAME: accountData.USERNAME }
      : {}),
  }

  console.log(respbody)
  const body = data
    ? {
      respbody,
    }
    : {}

  const getEndpoint = (endpoint) => {
    try {
      const parseEndpoint = organization.endpoints[`${endpoint}`].toString()

      if (parseEndpoint) {
        return parseEndpoint
      } else {
        throw endpoint
      }
    } catch (error) {
      return error
    }
  }

  const url = `${baseUrl}${getEndpoint(endpoint)}`

  try {
    const response = await request({
      url,
      method,
      headers,
      data: body,
      params,
    })

    if (response.data?.respcode === 5 || response.data?.respcode === 5) {
      const { getToken } = useAuthStore()
      token = await getToken()
      headers.Authorization = `Bearer ${token}`
      return makeRequest(endpoint, method, data, params, headers)
    }

    return response.data
  } catch (error) {
    throw error
  }
}

export default makeRequest
